import React, { useState } from 'react';
import {
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Card,
    CardContent,
    CardHeader,
    Avatar,
    Breadcrumbs,
    Link,
    TextField,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Collapse,
} from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// Sample data
const updates = [
    {
        date: '2023-10-01',
        version: '1.0.1',
        description: [
            'Fixed login issue and improved performance.',
            'Updated user interface for better accessibility.',
        ],
        type: 'fix',
    },
    {
        date: '2023-09-25',
        version: '1.0.0',
        description: [
            'Initial release with basic features.',
            'Added user authentication and authorization.',
        ],
        type: 'release',
    },
    // Add more updates as needed
];

const RecentUpdates = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('');
    const [expandedRows, setExpandedRows] = useState({});

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleClearSearch = () => {
        setSearchTerm('');
    };

    const handleFilterChange = (event) => {
        setFilterType(event.target.value);
    };

    const handleRowClick = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const filteredUpdates = updates.filter((update) => {
        return (
            (filterType === '' || update.type === filterType) &&
            (update.description.some((desc) => desc.toLowerCase().includes(searchTerm.toLowerCase())) ||
                update.version.includes(searchTerm) ||
                update.date.includes(searchTerm))
        );
    });

    return (
        <Container maxWidth="xlg" sx={{ height: '100vh' }}>
            <Box my={4}>
                {/* <Breadcrumbs aria-label="breadcrumb">
                    <Link color="inherit" href="/">
                        Home
                    </Link>
                    <Typography color="textPrimary">Recent Updates</Typography>
                </Breadcrumbs> */}
                <Typography variant="h4" component="h1" gutterBottom>
                    Recent Updates
                </Typography>
                <Card>
                    <CardHeader
                        //title="Updates"
                        subheader="Track the latest fixes and enhancements"
                    />
                    <CardContent>
                        <Box mb={2} display="flex" justifyContent="space-between">
                            <TextField
                                variant="outlined"
                                placeholder="Search updates"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleClearSearch}>
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{ width: '70%' }}
                            />
                            <FormControl variant="outlined" sx={{ width: '25%' }}>
                                <InputLabel>Filter by Type</InputLabel>
                                <Select
                                    value={filterType}
                                    onChange={handleFilterChange}
                                    label="Filter by Type"
                                >
                                    <MenuItem value="">
                                        <em>All</em>
                                    </MenuItem>
                                    <MenuItem value="fix">Fix</MenuItem>
                                    <MenuItem value="release">Release</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>
                        <TableContainer component={Paper} sx={{ maxHeight: '70vh' }} id="recent-changes-table-container">
                            <Table stickyHeader id="recent-changes-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Date</TableCell>
                                        <TableCell sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Version</TableCell>
                                        <TableCell sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Description</TableCell>
                                        <TableCell sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}>Type</TableCell>
                                        <TableCell sx={{ backgroundColor: '#f0f0f0', fontWeight: 'bold' }}></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredUpdates.map((update, index) => (
                                        <React.Fragment key={index}>
                                            <TableRow sx={{ '&:nth-of-type(odd)': { backgroundColor: 'surface.sunken' }, '&:hover': { backgroundColor: 'action.hover' } }}>
                                                <TableCell>{update.date}</TableCell>
                                                <TableCell>{update.version}</TableCell>
                                                <TableCell>{update.description[0]}</TableCell>
                                                <TableCell>
                                                    {update.type === 'fix' ? (
                                                        <Avatar sx={{ bgcolor: 'red' }}>
                                                            <BugReportIcon />
                                                        </Avatar>
                                                    ) : (
                                                        <Avatar sx={{ bgcolor: 'green' }}>
                                                            <NewReleasesIcon />
                                                        </Avatar>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <IconButton onClick={() => handleRowClick(index)}>
                                                        {expandedRows[index] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                    <Collapse in={expandedRows[index]} timeout="auto" unmountOnExit>
                                                        <Box margin={1}>
                                                            <Typography variant="subtitle1" gutterBottom component="div">
                                                                Details
                                                            </Typography>
                                                            <ul>
                                                                {update.description.map((desc, i) => (
                                                                    <li key={i}>{desc}</li>
                                                                ))}
                                                            </ul>
                                                        </Box>
                                                    </Collapse>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default RecentUpdates;